import * as Types from '@x/schemas/ecommerce';

import { gql } from 'apollo-angular';
import { ShopAdMediaFragmentDoc } from './shop-channel.gql.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ShopAdFragment = { __typename: 'ShopAdObject', id: number, url: string, urlTarget: string, targetChildrenTaxons: boolean, targetAuthorizationType: string, weight: number, targetTaxons: Array<{ __typename: 'ShopTaxonObject', path: string, id: number }>, targetRegions: Array<{ __typename: 'ShopTaxonObject', id: number }>, media: Array<{ __typename: 'ShopAdMediaObject', mediaQuery: string, placement?: string | null | undefined, type: string, url: string, width?: number | null | undefined, height?: number | null | undefined, alt?: string | null | undefined, originalName?: string | null | undefined }> };

export type ShopChannelAdsQueryVariables = Types.Exact<{
  channelCode: Types.Scalars['String']['input'];
  locale: Types.Scalars['String']['input'];
}>;


export type ShopChannelAdsQuery = { __typename: 'Query', shopAds: Array<{ __typename: 'ShopAdObject', id: number, url: string, urlTarget: string, targetChildrenTaxons: boolean, targetAuthorizationType: string, weight: number, targetTaxons: Array<{ __typename: 'ShopTaxonObject', path: string, id: number }>, targetRegions: Array<{ __typename: 'ShopTaxonObject', id: number }>, media: Array<{ __typename: 'ShopAdMediaObject', mediaQuery: string, placement?: string | null | undefined, type: string, url: string, width?: number | null | undefined, height?: number | null | undefined, alt?: string | null | undefined, originalName?: string | null | undefined }> }> };

export const ShopAdFragmentDoc = gql`
    fragment ShopAd on ShopAdObject {
  id
  url
  urlTarget
  targetTaxons {
    path
    id
  }
  targetRegions {
    id
  }
  targetChildrenTaxons
  targetAuthorizationType
  weight
  media {
    ...ShopAdMedia
  }
}
    ${ShopAdMediaFragmentDoc}`;
export const ShopChannelAdsDocument = gql`
    query ShopChannelAds($channelCode: String!, $locale: String!) {
  shopAds(channelCode: $channelCode, locale: $locale) {
    ...ShopAd
  }
}
    ${ShopAdFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopChannelAdsGQL extends Apollo.Query<ShopChannelAdsQuery, ShopChannelAdsQueryVariables> {
    document = ShopChannelAdsDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }